const labelRules = {
    '.Label': {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '120%',
        color: '#828282',
        padding: '0',
        marginBottom: '4px'
    }
}

const inputRules = {
    '.Input': {
        fontFamily: 'Lato',
        padding: '8px 16px',
        width: '100%',
        background: '#FFFFFF',
        border: '1px solid #BDBDBD',
        borderRadius: '4px',
        minHeight: '40px',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '140%',
        color: '#121A2C',
        display: 'flex',
        alignItems: 'center'
    },
    '.Input:focus': {
        borderColor: '#333333',
        outline: '0',
        fontWeight: '700',
        color: '#121A2C'
    },
    '.Input::placeholder': {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '140%'
    },
    '.Input--invalid': {
        marginBottom: '0',
        border: '1px solid #EB5757',
        color: '#121A2C'
    }
}

export const formRules = {
    ...labelRules,
    ...inputRules
}
